import React, { useEffect, useState } from "react";
import { Table, OverlayTrigger, Tooltip, Badge, Modal, Button } from "react-bootstrap";
import { MdWarningAmber } from "react-icons/md";
import { FiInfo, FiEye, FiFileText } from "react-icons/fi";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaAnomalie = () => {
  const [gruppiAnomalie, setGruppiAnomalie] = useState({});
  const [allLM, setAllLM] = useState([]); 
  const [conteggioLM, setConteggioLM] = useState({});
  const [loading, setLoading] = useState(true);
  const [totaleAlert, setTotaleAlert] = useState(0);

  // Stato per il modale anomalie standard
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  // Stati per il modale delle sole LM
  const [showLmModal, setShowLmModal] = useState(false);
  const [selectedLmRows, setSelectedLmRows] = useState([]);
  const [selectedLmFornitore, setSelectedLmFornitore] = useState("");

  useEffect(() => {
    fetch("ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const arrayAnomalie = (data?.ANOMALIE || []).flat();
        const arrayLM = (data?.LM || []).flat();
        
        setTotaleAlert(arrayAnomalie.length);
        setAllLM(arrayLM);

        // 1. Mappiamo e sommiamo le LM per ogni Ragione Sociale
        const mappaLM = {};
        arrayLM.forEach((lm) => {
          const ragioneSociale = lm["Ragione Sociale"] || "FORNITORE NON SPECIFICATO";
          mappaLM[ragioneSociale] = (mappaLM[ragioneSociale] || 0) + 1;
        });
        setConteggioLM(mappaLM);

        // 2. Raggruppiamo le anomalie standard per le testate
        const mappaAnomalie = {};
        arrayAnomalie.forEach((item) => {
          const key = item.ragione_sociale || "FORNITORE NON SPECIFICATO";
          if (!mappaAnomalie[key]) mappaAnomalie[key] = [];
          mappaAnomalie[key].push(item);
        });

        // 3. Includiamo nel gruppo anomalie anche i clienti che hanno SOLO LM
        Object.keys(mappaLM).forEach((ragioneSociale) => {
          if (!mappaAnomalie[ragioneSociale]) {
            mappaAnomalie[ragioneSociale] = [];
          }
        });

        setGruppiAnomalie(mappaAnomalie);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch:", err);
        setLoading(false);
      });
  }, []);

  const formatData = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "-";
    const soloData = dateStr.split(" ")[0];
    return soloData.split("-").reverse().join("/");
  };

  const formatNumero = (valore, decimali = 2) => {
    if (!valore) return "-";
    const num = parseFloat(valore);
    return isNaN(num) ? "-" : num.toFixed(decimali);
  };

  const getStatusStyle = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return { borderLeft: "4px solid #dee2e6" };
    const dataRimesso = new Date(dateStr.split(" ")[0]);
    const oggi = new Date();
    const diffDays = Math.floor((oggi - dataRimesso) / (1000 * 60 * 60 * 24));

    if (diffDays >= 15) return { borderLeft: "4px solid #dc3545" };
    if (diffDays >= 7) return { borderLeft: "4px solid #fd7e14" };
    if (diffDays >= 3) return { borderLeft: "4px solid #ffc107" };

    return { borderLeft: "4px solid #198754" };
  };

  const apriModaleCompleto = (item) => {
    setSelectedItem(item);
    setShowDetailModal(true);
  };

  const apriModaleLM = (e, ragioneSociale) => {
    e.stopPropagation(); 
    const righeFiltrate = allLM.filter(lm => lm["Ragione Sociale"] === ragioneSociale);
    setSelectedLmRows(righeFiltrate);
    setSelectedLmFornitore(ragioneSociale);
    setShowLmModal(true);
  };

  const renderTooltip = (props) => (
    <Tooltip id="info-anomalie-tooltip" {...props}>
      <div style={{ textAlign: "left", fontSize: "0.75rem", padding: "5px" }}>
        <strong>Invecchiamento riga:</strong>
        <br />• <span style={{ color: "#dc3545" }}>Rosso</span>: &gt; 15gg
        <br />• <span style={{ color: "#fd7e14" }}>Arancio</span>: &gt; 7gg
        <br />• <span style={{ color: "#ffc107" }}>Giallo</span>: &gt; 3gg
        <br />• <span style={{ color: "#198754" }}>Verde</span>: Recente
      </div>
    </Tooltip>
  );

  return (
    <div
      className="shadow-sm card"
      style={{
        borderRadius: "16px",
        border: "1px solid #eee",
        height: "380px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      {/* Header Widget */}
      <div className="p-3 bg-white border-bottom d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <span style={{ fontWeight: "800", fontSize: "0.75rem", color: "#1a1a1a", letterSpacing: "1px", marginRight: "8px" }}>
            ANOMALIE E DOCUMENTI LM
          </span>
          <OverlayTrigger placement="right" overlay={renderTooltip}>
            <span style={{ cursor: "pointer", display: "inline-flex", alignItems: "center" }}><FiInfo size={14} color="#adb5bd" /></span>
          </OverlayTrigger>
        </div>
        <Badge pill bg="danger" style={{ fontSize: "0.65rem", fontWeight: "700" }}>
          <MdWarningAmber className="me-1" /> {totaleAlert} ALERT RILEVATI
        </Badge>
      </div>

      <style>{`
        .scroll-area { overflow-y: auto; overflow-x: hidden; flex-grow: 1; background: #fff; }
        .table-anomalie { margin-bottom: 0; table-layout: fixed; width: 100%; border-collapse: separate; border-spacing: 0; }
        
        .testata-fornitore { 
          background-color: #f1f5f9 !important; 
          color: #334155 !important; 
          font-weight: 700; 
          font-size: 0.75rem; 
          padding: 8px 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          border-bottom: 1px solid #cbd5e1 !important;
        }
        
        .table-anomalie thead th { 
          position: sticky; top: 0; z-index: 20; 
          background-color: #f8f9fa !important; color: #64748b !important; 
          font-size: 0.65rem; text-transform: uppercase; padding: 10px 12px;
          border-bottom: 1px solid #dee2e6 !important;
          white-space: nowrap;
        }
        
        .table-anomalie tbody td { 
          font-size: 0.72rem; padding: 10px 12px; 
          vertical-align: middle; border-bottom: 1px solid #f1f5f9;
          white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        
        .row-cliccabile { cursor: pointer; transition: background 0.15s ease; }
        .row-cliccabile:hover { background-color: #f8fafc !important; }
        .click-lm { cursor: pointer; transition: color 0.2s; user-select: none; }
        .click-lm:hover { color: #0369a1 !important; text-decoration: underline; }
      `}</style>

      {/* Corpo della Tabella Principal */}
      <div className="scroll-area p-0">
        <Table hover className="table-anomalie border-0">
          <thead>
            <tr>
              <th style={{ width: "25%" }}>Causale</th>
              <th style={{ width: "25%" }}>Articolo</th>
              <th style={{ width: "25%" }}>Num. Rimesso</th>
              <th style={{ width: "25%" }}>Compl. BEM</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="5" className="text-center py-5 text-muted small">Generazione flusso dati...</td>
              </tr>
            ) : (
              Object.keys(gruppiAnomalie).map((ragioneSociale, gIdx) => (
                <React.Fragment key={gIdx}>
                  {/* TESTATA RAGIONE SOCIALE CENTRATA */}
                  <tr>
                    <td colSpan="5" className="testata-fornitore align-middle">
                      <div className="d-flex align-items-center justify-content-between">
                        <span className="mb-0">{ragioneSociale}</span>
                        {conteggioLM[ragioneSociale] > 0 && (
                          <span 
                            className="fw-bold text-primary click-lm d-flex align-items-center gap-1" 
                            style={{ fontSize: "0.7rem" }}
                            onClick={(e) => apriModaleLM(e, ragioneSociale)}
                          >
                            <FiFileText size={12} /> LM: {conteggioLM[ragioneSociale]}
                          </span>
                        )}
                      </div>
                    </td>
                  </tr>
                  
                  {/* RIGHE DETTAGLIO */}
                  {gruppiAnomalie[ragioneSociale].length === 0 ? (
                    <tr>
                      <td colSpan="5" className="text-muted ps-4 py-2" style={{ fontStyle: "italic", fontSize: "0.68rem" }}>
                      </td>
                    </tr>
                  ) : (
                    gruppiAnomalie[ragioneSociale].map((item, rIdx) => {
                      const statusStyle = getStatusStyle(item.data_rimesso);
                      return (
                        <tr key={rIdx} className="row-cliccabile" onClick={() => apriModaleCompleto(item)}>
                          <td style={statusStyle} className="fw-semibold text-danger text-truncate" title={item.causale}>
                            {item.causale}
                          </td>
                          <td className="fw-bold text-dark text-truncate" title={item.articolo}>
                            {item.articolo || "-"}
                          </td>
                          <td className="text-muted text-truncate" title={item.numero_rimesso}>
                            <small className="text-secondary">#</small>{item.numero_rimesso?.replace(/,$/, "") || "-"}
                          </td>
                          <td>{formatData(item.data_completamento_bem)}</td>
                          
                        </tr>
                      );
                    })
                  )}
                </React.Fragment>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {/* MODALE 1: DETTAGLIO ANOMALIA SINGOLA */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} size="lg" centered className="p-5">
        <Modal.Header closeButton className="bg-light">
          <Modal.Title style={{ fontSize: "0.9rem", fontWeight: "800" }} className="text-dark">
            {selectedItem?.ragione_sociale}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3">
          <Table responsive  hover className="align-middle m-0" style={{ fontSize: "0.8rem" }}>
            <thead className="table-light">
              <tr>
                <th>Articolo</th>
                <th>Data Rimesso</th>
                <th>Completamento BEM</th>
                <th>Causale</th>
                <th>Numero Rimesso</th>
              </tr>
            </thead>
            <tbody>
              {selectedItem && (
                <tr>
                  <td className="fw-bold text-primary">{selectedItem.articolo || "-"}</td>
                  <td>{formatData(selectedItem.data_rimesso)}</td>
                  <td className={selectedItem.data_completamento_bem ? "text-success fw-medium" : "text-muted"}>
                    {selectedItem.data_completamento_bem ? formatData(selectedItem.data_completamento_bem) : "In attesa"}
                  </td>
                  <td className="text-danger fw-semibold">{selectedItem.causale || "-"}</td>
                  <td className="font-monospace">
                    {selectedItem.numero_rimesso ? `#${selectedItem.numero_rimesso.replace(/,$/, "")}` : "-"}
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="bg-light p-2">
          <Button variant="secondary" size="sm" onClick={() => setShowDetailModal(false)} style={{ borderRadius: "6px" }}>Chiudi</Button>
        </Modal.Footer>
      </Modal>

      {/* MODALE 2: TABELLA DETTAGLIATA REGISTRO DOCUMENTI LM */}
      <Modal show={showLmModal} onHide={() => setShowLmModal(false)} size="xl" centered className="p-5">
        <Modal.Header closeButton className="bg-dark text-white">
          <Modal.Title style={{ fontSize: "0.95rem", fontWeight: "800" }}>
            REGISTRO DOCUMENTI LM — {selectedLmFornitore}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3" style={{ maxHeight: "500px", overflowY: "auto" }}>
          <Table responsive  hover  className="align-middle m-0" style={{ fontSize: "0.78rem" }}>
            <thead className="table-light sticky-top" style={{ top: 0, zIndex: 1 }}>
              <tr>
                <th>ID Fornitore</th>
                <th>Dep</th>
                <th>Tipo Doc</th>
                <th>Num Doc</th>
                <th>Data Doc</th>
                <th>Precodice</th>
                <th>Articolo</th>
                <th>Descrizione</th>
                <th>Qta</th>
                <th>Netto (€)</th>
                <th>Importo (€)</th>
                <th>Note Lista / Dettagli Reso</th>
              </tr>
            </thead>
            <tbody>
              {selectedLmRows.map((lm, index) => (
                <tr key={index}>
                  <td>{lm["ID Fornitore"] || "-"}</td>
                  <td className="text-center">{lm["Deposito"] || "-"}</td>
                  <td className="fw-bold text-info">{lm["Tipo Doc"] || "LM"}</td>
                  <td className="fw-semibold">#{lm["Num Doc"] || "-"}</td>
                  <td>{formatData(lm["Data Doc"])}</td>
                  <td>{lm["Precodice"] || "-"}</td>
                  <td className="fw-bold text-primary">{lm["Articolo"] || "-"}</td>
                  <td className="text-truncate" style={{ maxWidth: "150px" }} title={lm["Descrizione"]}>{lm["Descrizione"] || "-"}</td>
                  <td className="fw-bold text-center">{formatNumero(lm["Qta"], 0)}</td>
                  <td>{formatNumero(lm["Netto"], 2)}</td>
                  <td className="fw-bold">{formatNumero(lm["Importo"], 2)}</td>
                  <td className="text-muted small" style={{ maxWidth: "220px", whiteSpace: "normal" }}>{lm["Note Lista"] || lm["Note Doc"] || "-"}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="bg-light p-2">
          <Button variant="outline-dark" size="sm" onClick={() => setShowLmModal(false)} style={{ borderRadius: "6px" }}>
            Chiudi Registro
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default TabellaAnomalie;